import { useEffect, useState } from "react";
import type { GrowRates } from "utils/grow";
import { getStaticStakingRates } from ".";

export type StakingRates = {
  maxStakingRewardRate: string;
  minStakingRewardRate: string;
} & Omit<GrowRates, "maxAPY" | "minAPY">;
const useStaking = () => {
  const [growRates, setGrowRates] = useState<GrowRates>({
    interestRates: [],
    hasError: false,
    minAPY: "0",
    maxAPY: "0"
  });
  useEffect(() => {
    async function loadData() {
      const rates = await getStaticStakingRates();
      setGrowRates(rates);
    }
    loadData();
  }, []);

  return {
    interestRates: growRates.interestRates,
    hasError: growRates.hasError,
    minStakingRewardRate: growRates.minAPY,
    maxStakingRewardRate: growRates.maxAPY
  };
};

export { useStaking };
